import { List, Record, Map } from 'immutable';

export const PriceRecord = Record({
  'ppp_id': '',
  'p_id': '',
  'pp_id': '',
  'pepole_num1': 0,
  'pepole_num2': 0,
  'date_price': 0,
  'date': '',
  'adult_cost_price': 0,
  'adult_num': 0,
  'child_cost_price': 0,
  'child_num': 0,
  'diff_cost_price': 0,
  'supplier_id': 0,
  'selectType': '',
  'weekSelect': '',
  'dateIntervalOrMultiple': 1,
});

export const PackageRecord = Record({
  'pp_id': '',
  'p_id': '',
  'title': '套餐',
  'sku_code': '',
  'describes': '',
  'labels': '',
  // 'createtime': '',
  'remrak': '',
  'supplier': { 's_id': '', 'company': '' },
  'supplier_id': '',
  'supplier_suffix': { 'key': '', 'label': '' },
  'supplier_suffix_id': '',
  'price_list': List([]),
  'destination': { 'a_id': '', 'label': '' },
  'destination_id': 0,
  'unit_id': 0,
  'currency': { c_id: 1, title: "人民币", code: "CNY", exchange_rate: 1 },
  'currency_id': 1,
  'exchange_rate': 1,
  'is_default_supplier': 0,
  'is_draft': 1,
  'hm_pp_ids': '',
  'hm_pp_list': {},
  'insurance': 0,
  'insurance_included': 0,
  'duplicate_excluded': 0,
});

export const ProductRecord = Record({
  'p_id': '',
  'title': '',
  'describes': '',
  'labels': '',
  // 'createtime': '',
  'create_user_id': '',
  'sku_code': '',
  'pc_id': '',
  'lastedit_user_id': '',
  'package_list': List([new PackageRecord()]),
  'loading': true,
  delQueueRackage: List([]),
  delQueuePrice: List([]),
});
